import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { actions } from '../../features/bestFriends';
import { sendEvent } from '../../lib/google-analytics';
import { Dialog } from '../shared/dialog/Dialog';
import { ConfirmBlock } from './ConfirmBlock';

export const OptionalBlockDialog: React.FC = () => {
  const { t } = useTranslation('best_friends');
  const { id } = useParams<{ id?: string }>();
  const history = useHistory();
  const dispatch = useDispatch();

  const onBlockClick = useCallback(() => {
    if (id) {
      dispatch(actions.deleteFriend({ id }));
      sendEvent('best_friends_block', 'click', 'report');
    }
  }, [id, dispatch]);

  const onCancelClick = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <Dialog hasHeader={true} title={t('dialog_delete_best_friends')}>
      <ConfirmBlock
        description={t('dialog_delete_ask_01')}
        confirm={t('button_delete_best_friends')}
        gaEventLabel={'report'}
        onBlockClick={onBlockClick}
        onCancelClick={onCancelClick}
      />
    </Dialog>
  );
};
